import { render } from "./FAQView.vue?vue&type=template&id=d5755598&scoped=true"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=d5755598&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5755598"]])

export default __exports__